import { baseUrl } from "./seoConfig";

export const personSchema = {
	"@context": "https://schema.org",
	"@type": "Person",
	name: "Ibrohimbek Alisherov",
	url: baseUrl,
	image: `${baseUrl}/avatar.jpg`,
	jobTitle: "Web Developer",
	description:
		"Web developer specializing in React, Next.js, and modern frontend technologies.",
	sameAs: [
		"https://github.com/ibrohimbek-dev",
		"https://linkedin.com/in/ibrohimbek-dev",
		"https://instagram.com/ibek0127",
		"https://linktr.ee/dev_ibrohimbek",
	],
	knowsAbout: [
		"Web Development",
		"React",
		"Next.js",
		"JavaScript",
		"TypeScript",
		"Frontend Development",
		"UI/UX",
	],
};
